import { FCX, ID } from '@models';
import TilesCarousel from '@components/TilesCarousel';
import React, { memo } from 'react';
import { useFiltersContext } from '@core/FiltersContext';
import { useChainProfileRecentlyReleasedItems } from '@api/useChainProfileRecentlyReleasedItems';
import { IconSpinner } from '@svg/index';
import DataFallback from '@components/DataFallback';

const RecentlyReleasedItems: FCX<{
    chainId: ID;
    chainName: string;
    isGlobalLoading: boolean;
}> = ({
    chainId,
    chainName,
}) => {
    const { options: { totalRespondentType } } = useFiltersContext();
    const { data, isLoading } = useChainProfileRecentlyReleasedItems(chainId);

    return (
        <div className="flex-row flex-row-details">
            <div className="flex-col-12" style={{ position: 'relative' }}>
                <div className="card-header" style={{ display: 'flex', alignItems: 'center' }}>
                    <div className="color-dimyellow">{chainName}</div>
                    &nbsp;Recently Launched Items & LTO's
                </div>
                {isLoading ? (
                    <div style={{
                        width: '100%',
                        height: 200,
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                    }}>
                        <IconSpinner/>
                    </div>
                ) : (
                    <>
                        {data.length > 0 ? (
                            <TilesCarousel
                                key={chainId}
                                data={data}
                                tileIndexId={totalRespondentType.id}
                                denyAlternativeChainOptions

                            />
                        ) : (
                            <div className="card">
                                <div className="card-content">
                                    <DataFallback
                                        style={{ opacity: isLoading ? 0 : 1 }}
                                        title="No items found"
                                    />
                                </div>
                            </div>
                        )}
                    </>
                )}
            </div>
        </div>
    );
};

export default memo(RecentlyReleasedItems);